import { gsap, SplitText } from "./gsapSetup";

export function prepareAboveFold() {
  const titleEl = document.querySelector(".gs-title");
  if (!titleEl) return;

  // hide instantly to avoid flash
  gsap.set(titleEl, { autoAlpha: 0 });
}

export function playAboveFold() {
  const titleEl = document.querySelector(".gs-title");
  if (!titleEl) return;

  // Split + animate immediately (no ScrollTrigger)
  const split = SplitText.create(titleEl, { type: "lines,words", mask: "lines" });

  split.lines.forEach(line => {
    line.style.paddingBottom = "0.18em";
    line.style.marginBottom = "-0.18em";
  });

  // reveal and animate
  gsap.set(titleEl, { autoAlpha: 1 });

  return gsap.from(split.words, {
    y: 80,
    autoAlpha: 0,
    duration: 1,
    stagger: 0.05,
    ease: "power2.out",
    // optional: onComplete: () => split.revert()
  });
}

function resolveColor(value) {
  // Tailwind class (text-*) -> computed color
  if (value && value.startsWith("text-")) {
    const tmp = document.createElement("span");
    tmp.className = value;
    tmp.style.display = "none";
    document.body.appendChild(tmp);
    const color = getComputedStyle(tmp).color;
    tmp.remove();
    return color;
  }
  // Raw CSS color (#fff, rgb(), hsl(), etc.)
  return value;
}


export default function runGsapLogic() {
  const titleEl = document.querySelector(".gs-title");
  const subTitles = document.querySelectorAll(".gs-subtitle");
  const h5Titles = document.querySelectorAll(".gs-kicker");
  const h5InlineBlockTitles = document.querySelectorAll(".gs-shine");
  const pricingTitles = document.querySelectorAll(".gs-color");

  // (Optional) respect reduced motion
  const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (prefersReduced) return;

  // ---- Title ----
  if (titleEl) {
    SplitText.create(titleEl, {
      type: "lines,words",
      mask: "lines",
      onSplit(self) {
        // Give each masked line a little extra "descender room"
        self.lines.forEach(line => {
          line.style.paddingBottom = "0.18em";
          line.style.marginBottom = "-0.18em";
        });

        return gsap.from(self.words, {
          scrollTrigger: { trigger: titleEl, start: "top 85%", once: true },
          y: 80,
          autoAlpha: 0,
          duration: 1,
          stagger: 0.05,
          ease: "power2.out",
        });
      }
    });
  }

  // h2
  subTitles.forEach(el => {
    const split = SplitText.create(el, {
      type: "words,chars",
    });
    gsap.from(split.chars, {
      scrollTrigger: {
        trigger: el,
        start: "top 85%",
        toggleActions: "play none none none",
        once: true,
      },
      y: 20,
      autoAlpha: 0,
      duration: 0.8,
      stagger: 0.02,
      ease: "power2.out",
      // onComplete: () => split.revert(),
    });
  });

  // h5
  h5Titles.forEach(el => {
    const split = SplitText.create(el, {
      type: "words,chars",
    });
    gsap.from(split.chars, {
      scrollTrigger: {
        trigger: el,
        start: "top 85%",
        toggleActions: "play none none none",
        once: true,
      },
      y: 20,
      autoAlpha: 0,
      duration: 1,
      stagger: 0.05,
      ease: "power2.out",
      // onComplete: () => split.revert(),
    });
  });

  // h5 // 2
  h5InlineBlockTitles.forEach(el => {
    if (el.dataset.animated === "true") return;
    el.dataset.animated = true;

    let beam = el.querySelector(".gs-shine__beam");
    if (!beam) {
      beam = document.createElement("span");
      beam.className = "gs-shine__beam";
      el.appendChild(beam);
    }

    const color = el.dataset.shine || "rgba(122,227,106,.6)";
    el.style.setProperty("--shine-color", color);

    const tl = gsap.timeline({
      delay: 0,
      scrollTrigger: {
        trigger: el,
        start: "top 85%",
        once: true,
      },
    });

    tl.set(beam, {
      xPercent: -120,
      yPercent: -120,
      opacity: 0,
    })
      .to(beam, {
        opacity: 1,
        duration: 0.12,
        ease: "power1.out",
      })
      .to(
        beam,
        {
          xPercent: 120,
          yPercent: 120,
          duration: 2.4,
          ease: "none",
        },
        "<"
      )
      .to(
        beam,
        {
          opacity: 0,
          duration: 0.2,
          ease: "power1.in",
        },
        "-=0.2"
      );
  });

  // colors (plans titles)
  pricingTitles.forEach((el, index) => {
    if (el.dataset.animated === "true") return;
    el.dataset.animated = "true";

    const base = resolveColor(el.dataset.base || "text-white");
    const paint = resolveColor(el.dataset.paint || "text-blue-500");

    const split = new SplitText(el, { type: "chars" });
    const chars = split.chars;

    // Start in base (white)
    gsap.set(chars, { color: base });

    const tl = gsap.timeline({
      delay: index * 0.5,
      scrollTrigger: {
        trigger: el,
        start: "top 85%",
        toggleActions: "play none none none"
      }
    });

    // Paint forward: white -> blue (S then t then a...)
    tl.to(chars, {
      color: paint,
      duration: 0.25,
      ease: "none",
      stagger: { each: 0.05, from: "start" }
    });

    // Small gap (optional)
    if (0.15 > 0) tl.to({}, { duration: 0.15 });

    // Paint back: blue -> white in reverse order (r -> e -> t -> ...)
    tl.to(chars.reverse(), {
      color: base,
      duration: 0.25,
      ease: "none",
      stagger: { each: 0.05, from: "end" }
    });
  });

}
